import LoginService from '@/services/login.service';
import BatchSubmit from '@/components/data-form/batch-submit/batch-submit.vue';
import DataSource from '@/services/data-source.service';
import ListSettingService from '@/services/list-setting.service';
import { PropertyState } from '@/models/form-design/property-schema-view-model';
import { uuid, IsArray, IsNull, CreateUUID } from '../../utils/utils';
import { DataLogicType } from '@/models/form-design/bizobject-schema-property-model';
import { PropertySchemaViewModel } from '@/models/form-design/property-schema-view-model';
import { Message } from 'element-ui';
import { ConditionValueType } from '@/models/search-condition.js';
import AppService from '@/services/app.service.js';
import WebpartItem from '@/components/webparts/webpart-item.js';
import DataListService from '@/services/data-list.service';
import DataListParam from '@/models/data-list/data-list-param';
import DataFormParameters from '@/models/data-form-parameters.js';
import FormViewType from '@/models/form-view-type.js';
import systemService from '@/services/system-service';

export default {
    /**
     * 加密key
     * @param privateKey 私钥
     * @param effectiveTime 过期时间
     */
    encodeUserKey(privateKey) {
        let Base64 = require('js-base64').Base64;
        // (base64登录名 +私钥(whdac)+base64时间)  =>base64加密
        const uCode = LoginService.userInfo.Code;
        const format = 'yyyyMMddhhmmss';
        const dateCode = Base64.encode(this.Format(new Date(), format));
        const userCode = Base64.encode(uCode);
        const keyValue = Base64.encode(userCode + privateKey + dateCode);
        return keyValue;
    },

    /**
     * 解密key
     * @param key
     * @param privateKey 私钥
     */
    decodeUserKey(key, privateKey) {
        let Base64 = require('js-base64').Base64;
        //登录名 加密=> MDA2ODI1 +私钥(whdac)+时间戳  =>加密
        const dateKey = Base64.encode(this.Format(new Date(), 'yyyyMMdd'));
        const decode1 = Base64.decode(key)
            .replace(privateKey, '')
            .replace(dateKey, '');
        const keyValue = Base64.decode(decode1);
        return keyValue;
    },
    formatter(v) {
        var t = '未知';
        if (v) {
            switch (v) {
                case 1:
                    t = 'Web端';
                    break;
                case 2:
                    t = 'App';
                    break;
                case 3:
                    t = '企业微信';
                    break;
            }
        }
        return t;
    },
    /**
     * 时间格式化方法
     *
     * @static
     * @param {Date} date 日期对象
     * @param {string} ext 格式化参数 hh:mm:ss
     * @memberof CommonMethod
     */
    Format(date, ext) {
        if (typeof date == 'string') {
            return date;
        }
        if (!date) date = new Date();

        var o = {
            'M+': date.getMonth() + 1, //月份
            'd+': date.getDate(), //日
            'h+': date.getHours(), //小时
            'm+': date.getMinutes(), //分
            's+': date.getSeconds(), //秒
            'q+': Math.floor((date.getMonth() + 3) / 3), //季度
            S: date.getMilliseconds(), //毫秒
        };
        if (/(y+)/.test(ext))
            ext = ext.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp('(' + k + ')').test(ext))
                ext = ext.replace(
                    RegExp.$1,
                    RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
                );
        return ext;
    },
    getSapCols(res) {
        var showCols = [];
        if (!res.Result[0] || !res.Result[0].ItemValue) return showCols;
        res.Result[0].ItemValue[0].forEach(element => {
            showCols.push({
                Title: element,
                Code: element,
            });
        });
        return showCols;
    },
    goToInvokeService(res) {
        if (!res.Success) {
            Message(res.Message);
            return false;
        }
        if (res.Result == false) {
            return false;
        }
        if (res.Result == true) {
            return true;
        }
        if (!res.Result || !res.Result.length) {
            return false;
        }
        return true;
    },
    batchSubmit(othis, type, multipleSelected, callback) {
        var str = new Array();
        multipleSelected.forEach(items => {
            str.push(items.FlowItemId);
        });
        if (str.length == 0) {
            othis.common.showMessageView('请选择批量审批项!', 'warning');
            return;
        }
        var title = '批量审批';
        if (type == 1) {
            title = '批量拒绝';
        }
        othis.$modal.show({
            //title: title+`您选择了${str.length}条任务，请输入<span style="color:#FF0000">提交</span>意见`,
            title: title,
            content: BatchSubmit,
            componentParams: {
                selectedItems: str,
                batchType: type,
            },
            width: '400px',
            confirmHandler: () => {
                callback();
            },
        });
    },
    checkSubName(title, itemName, name, subDataSource, propertyState) {
        if (!subDataSource || subDataSource.length == 0) {
            return '';
        }
        var warning = '';
        if (!title.trim()) {
            warning = '请输入子表名称!';
        } else if (title == '系统字段' || title == '用户字段') {
            warning = "子表名称不能是'系统名称'或'用户名称'";
        } else {
            var results = subDataSource.filter(c => c.Item && !c.Item.IsDel);
            //编辑情况，过滤自己
            if (propertyState == PropertyState.Update) {
                results = subDataSource.filter(
                    c =>
                    c.Item &&
                    !c.Item.IsDel &&
                    c.Item.ItemName != itemName &&
                    c.Item.RelateName != name
                );
            }
            //检查标题重复
            var elements = results.filter(c => c.Item && c.Item.DisplayName == title);
            if (elements && elements.length > 0) {
                warning = '与子表[' + title + ']的标题重复，请重新输入标题!';
            }
            if (itemName || name) {
                //检查名称重复
                elements = results.filter(
                    c =>
                    c.Item &&
                    ((itemName && c.Item.ItemName == itemName) ||
                        (name && c.Item.RelateName == name))
                );
                if (elements && elements.length > 0) {
                    warning = '与子表[' + title + ']的名称重复，请重新输入名称!';
                }
            }
        }
        return warning;
    },
    /**
     * 判断主表字段是否为系统保留字段
     * @param {String} str
     */
    isSystemField(str) {
        const systemFields = [
            'ObjectID',
            'Name',
            'State',
            'SequenceNo',
            'CreatedName',
            'IDFullPath',
            'NameFullPath',
            'CreatedParentName',
            'CreatedParentCode',
            'WorkFlowVersion',
            'CreatedBy',
            'CreatedByParentId',
            'OwnerId',
            'OwnerParentId',
            'CreatedTime',
            'ModifiedBy',
            'ModifiedTime',
            'RunningInstanceId',
            'FolderId',
            'FileContent',
            'ParentObjectID',
            'TreeListParentID',
            'ParentIndex',
            'ParentPropertyName',
        ];
        if (str) {
            return systemFields.findIndex(c => c.toLowerCase() == str.toLowerCase()) > -1;
        }
        return false;
    },
    /**
     * 判断子表字段是否为系统保留字段
     * @param {String} str
     */
    isSubSystemField(str) {
        const systemFields = ['ObjectID', 'RelObjectID'];
        if (str) {
            return systemFields.findIndex(c => c.toLowerCase() == str.toLowerCase()) > -1;
        }
        return false;
    },
    /**
     * 判断主表字段是否重复
     * @param {String} title 字段标题
     * @param {String} code  字段CODE
     * @param {Array} dataSource  数据源
     * @param {PropertyState} propertyState 操作状态
     * @param {*} item       编辑字段
     */
    checkSystemName(code) {
        if (code && (code.toLowerCase() == 'objectid' || code.toLowerCase() == 'parentindex' || code.toLowerCase() == 'parentobjectid' ||
                code.toLowerCase() == 'parentpropertyname' || code.toLowerCase() == 'name' || code.toLowerCase() == 'state' ||
                code.toLowerCase() == 'sequenceno' || code.toLowerCase() == 'treelistparentid' || code.toLowerCase() == 'createdname' ||
                code.toLowerCase() == 'idfullpath' || code.toLowerCase() == 'namefullpath' || code.toLowerCase() == 'createdparentname' ||
                code.toLowerCase() == 'sheetcode' || code.toLowerCase() == 'workflowversion' || code.toLowerCase() == 'createdby' ||
                code.toLowerCase() == 'createdbyparentid' || code.toLowerCase() == 'ownerid' || code.toLowerCase() == 'ownerparentid' ||
                code.toLowerCase() == 'createdtime' || code.toLowerCase() == 'modifiedby' || code.toLowerCase() == 'modifiedtime' ||
                code.toLowerCase() == 'runninginstanceid' || code.toLowerCase() == 'bizsheetversion' || code.toLowerCase() == 'flowstatus' ||
                code.toLowerCase() == 'flowitemid' || code.toLowerCase() == 'applytime')) {
            return true;
        }
        return false;
    },
    checkNameExist(title, code, dataSource, propertyState, item = null) {
        if (IsNull(title)) {
            return '字段标题不能为空';
        }
        if (!dataSource || dataSource.length === 0) {
            return '';
        }

        var dataCopy = JSON.parse(JSON.stringify(dataSource));
        if (propertyState === PropertyState.Update) {
            let isSystem = this.isSystemField(item.code);
            if (isSystem) {
                dataCopy = dataCopy.filter(t => t.code != item.code);
            } else {
                dataCopy = dataCopy.filter(t => t.RelateName != item.RelateName);
            }
            if (!dataCopy || dataCopy.length === 0) return '';
        }
        var warning = '';
        //检查标题重复
        var elements = dataCopy.filter(
            c => !c.IsDel && c.DisplayName.toLowerCase() == title.toLowerCase()
        );
        if (elements && elements.length > 0) {
            warning = '与字段[' + elements[0].DisplayName + ']的标题重复，请重新输入标题!';
        }
        // 检查名称重复
        if (!IsNull(code)) {
            if (item && this.isSystemField(item.code)) {
                elements = dataCopy.filter(c => c.code.toLowerCase() == code.toLowerCase());
            } else {
                elements = dataCopy.filter(
                    c => c.RelateName && c.RelateName.toLowerCase() == code.toLowerCase()
                );
            }
            if (elements && elements.length > 0) {
                warning = '与字段[' + elements[0].DisplayName + ']的名称重复，请重新输入名称!';
            }
        }
        return warning;
    },
    checkSubItemName(title, itemName, parentName, name, subDataSource, propertyState) {
        if (!subDataSource || subDataSource.length == 0) {
            return '';
        }
        var warning = '';
        if (!title.trim()) {
            warning = '请输入字段名称!';
        } else {
            var result = subDataSource.find(c => c.Item.ItemName == parentName);
            if (!result || !result.Result || result.Result.length == 0) return '';
            var results = result.Result;
            //编辑情况，过滤自己
            if (propertyState == PropertyState.Update) {
                results = result.Result.filter(c => c.ItemName != itemName && c.RelateName != name);
            }
            //检查标题重复
            var elements = results.filter(
                c => !c.IsDel && c.DisplayName.toLowerCase() == title.toLowerCase()
            );
            if (elements && elements.length > 0) {
                warning = '与字段[' + title + ']的标题重复，请重新输入标题!';
            }
            if (itemName || name) {
                if (this.isSubSystemField(name)) {
                    warning = '与系统字段[' + name + ']的名称重复，请重新输入标题!';
                } else {
                    //检查名称重复
                    elements = results.filter(
                        c =>
                        (itemName && c.ItemName == itemName) ||
                        (name && c.RelateName.toLowerCase() == name.toLowerCase())
                    );
                    if (elements && elements.length > 0) {
                        warning = '与字段[' + title + ']的名称重复，请重新输入名称!';
                    }
                }
            }
        }
        return warning;
    },
    saveDataSource(datas, source, formLayout, subFormLayout, fun) {
        if (!datas) {
            return null;
        }
        if (!IsArray(datas)) {
            var d = [];
            d.push(datas);
            datas = d;
        }
        datas = this.getExtendDataSourItemByUpdate(datas);
        datas.forEach(element => {
            if (element.$type) {
                delete element.$type;
            }
        });
        DataSource.saveDataSource(datas).then(res => {
            if (res.Success && fun) {
                fun();
            }
            if (source && res && res.Result) {
                datas.forEach(element => {
                    //子表
                    if (element.LogicType == DataLogicType.BizObjectArray) {
                        this.updateSubTable(element, source, formLayout, subFormLayout);
                    }
                    //字段
                    else {
                        //子表字段
                        if (element.ParentProperty) {
                            this.updateSubItem(element, source, subFormLayout);
                        }
                        //主表字段
                        else {
                            this.changeSystemFieldType(element);
                            this.updateMainItem(element, source, formLayout);
                        }
                    }
                    this.updateListSettingByField(
                        element.PropertyState,
                        element.SchemaCode,
                        element.DisplayName,
                        element.ItemName
                    );
                });
            }
        });
    },
    changeSystemFieldType(element) {
        if (element.ItemName == 'CreatedTime' || element.ItemName == 'ModifiedTime') {
            element.LogicType = 'DateTime';
            element.LogicTypeName = 'DateTime';
        }
    },
    getExtendDataSourItemByUpdate(datas) {
        var datasExtendProperty = [];
        datas.forEach(element => {
            if (
                (element.ItemName.lastIndexOf('_') == 1 ||
                    element.ItemName.lastIndexOf('_') == -1) &&
                element.PropertyState == PropertyState.Update &&
                element.ExtendProperty &&
                element.ExtendProperty.length > 0
            ) {
                element.ExtendProperty.forEach(ele => {
                    var a = ele.DisplayName.substr(0, ele.DisplayName.lastIndexOf('_'));
                    var b = ele.RelateName.substr(0, ele.RelateName.lastIndexOf('_'));
                    var newName = ele.DisplayName.replace(a, element.DisplayName);
                    var newRelateName = ele.RelateName.replace(b, element.RelateName);
                    var c = this.createDataSourItem(
                        element.schemaCode,
                        newName,
                        ele.ItemName,
                        newRelateName,
                        ele.RelateName,
                        ele.LogicType,
                        ele.ParentProperty,
                        PropertyState.Update,
                        '',
                        ele.ComponentKey
                    );
                    datasExtendProperty.push(c);
                    ele.DisplayName = newName;
                    ele.RelateName = newRelateName;
                });
            }
            this.changeSystemFieldType(element);
        });
        return datas.concat(datasExtendProperty);
    },
    getFormDataInfo(val, funcItemCode, searchConditions, callBack = null) {
        searchConditions.forEach(element => {
            if (
                element.ValueType == ConditionValueType.System ||
                element.ValueType == ConditionValueType.FormField
            ) {
                element.value = val[element.Value] ? val[element.Value] : element.Value;
            }
        });
        var listParams = new DataListParam(null);
        listParams.AppItemCode = funcItemCode;
        listParams.SearchCondition = searchConditions;
        AppService.getAppItemView(funcItemCode).then(res => {
            if (!res.Success) {
                callBack(null);
                // Message.error("在-" + funcItemName + "-中未找到" + col + "相关数据");
                return;
            }
            try {
                var webPartItems = res.Result.Container.Components.map(
                    item => new WebpartItem(item)
                );
                const dataListWebPartItem =
                    webPartItems.length > 1 ? webPartItems[1] : webPartItems[0];
                DataListService.getListDataByCondition(
                    dataListWebPartItem.DataUrl,
                    listParams
                ).then(r => {
                    if (r.Result && r.Result.Datas && r.Result.Datas[0]) {
                        var data = r.Result.Datas[0];
                        const retVal = new DataFormParameters({
                            appItemType: dataListWebPartItem.AppFunctionType,
                            formViewType: FormViewType.View,
                            isWorkFlow: dataListWebPartItem.IsWorkflow,
                            isSubForm: false,
                            flowId: data.RunningInstanceId,
                            formCode: funcItemCode,
                            dataId: data.ObjectID,
                            state: data.State,
                        });
                        if (callBack) {
                            callBack(retVal);
                        }
                        return retVal;
                    } else {
                        callBack(null);
                        // Message.error("在-" + funcItemName + "-中未找到" + col + "相关数据");
                    }
                });
            } catch {
                callBack(null);
                // Message.error("在-" + funcItemName + "-中未找到" + col + "相关数据");
            }
        });
    },
    /**
     * 同步数据源与列表字段
     * @param {Number} type      必填
     * @param {String} itemCode  必填
     * @param {String} title
     * @param {String} code          {"Title": "string","Code": "string"}
     */
    updateListSettingByField(type, itemCode, title, code) {
        // ListSettingService.updateListSettingByField(type, itemCode, { "Title": title, "Code": code }, subCode).then(res => {
        //     if (res.Success && res.Result) {
        //         console.log("列表数据源字段同步:", "type:" + type + ",title:" + title + ",code:" + code);
        //     }
        // });
        ListSettingService.updateListSettingByField(type, itemCode, {
            Title: title,
            Code: code,
        }).then(res => {
            if (res.Success && res.Result) {
                console.log(
                    '列表数据源字段同步:',
                    'type:' + type + ',title:' + title + ',code:' + code
                );
            }
        });
    },
    updateSubTable(element, source, formLayout, subFormLayout) {
        switch (element.PropertyState) {
            case PropertyState.Add:
                source.push({
                    Item: element,
                    Result: [],
                    PropertyState: PropertyState.Update,
                });
                subFormLayout.push({
                    code: element.ItemName,
                    title: element.DisplayName,
                    Data: {
                        layoutDetail: [],
                    },
                });
                break;
            case PropertyState.Update:
                var item = source.find(c => c.Item.ItemName == element.ItemName);
                if (item) {
                    item.Item.DisplayName = element.DisplayName;
                    item.Item.RelateName = element.RelateName;
                }
                if (!subFormLayout || subFormLayout.length == 0) return;
                var l = subFormLayout.find(c => c.code == element.ItemName);
                if (l) l.title = element.DisplayName;
                if (formLayout && formLayout.Data && formLayout.Data.layoutDetail) {
                    var tk = formLayout.Data.layoutDetail.find(c => c.code == element.ItemName);
                    if (tk) {
                        tk.title = element.DisplayName;
                    }
                }
                break;
            case PropertyState.Del:
                var r = source.find(c => c.Item.ItemName == element.ItemName);
                if (!r) return;
                r.Item.PropertyState = PropertyState.Del;
                r.Item.IsDel = true;
                //修改子表字段删除状态
                if (r.Result && r.Result.length > 0) {
                    r.Result.forEach(el => {
                        el['PropertyState'] = PropertyState.Del;
                        el['IsDel'] = true;
                    });
                }
                //删除主表表单上的子表
                if (formLayout && formLayout.Data && formLayout.Data.layoutDetail) {
                    formLayout.Data.layoutDetail.forEach((ele, index) => {
                        if (ele.code == element.ItemName) {
                            formLayout.Data.layoutDetail.splice(index, 1);
                            return false;
                        }
                    });
                }
                //删除子表tab页
                subFormLayout.forEach((ele, index) => {
                    if (ele.code == element.ItemName) {
                        subFormLayout.splice(index, 1);
                        return false;
                    }
                });
                break;
        }
    },
    updateSubItem(element, source, subFormLayout) {
        var item = source.find(c => c.Item.ItemName == element.ParentProperty);
        if (!item) return;
        if (!item.Result) item.Result = [];
        if (!item.Item.SystemFields) item.Item.SystemFields = [];
        switch (element.PropertyState) {
            case PropertyState.Add:
                if (element.Indexed) {
                    if (element.ItemName.indexOf('_Id') == -1) {
                        var k = item.Item.SystemFields.find(k => k.ItemName == element.ItemName);
                        if (k == null) {
                            item.Item.SystemFields.push(element);
                        } else {
                            k.IsDel = false;
                        }
                    }
                } else {
                    item.Result.push(element);
                }
                break;
            case PropertyState.Update:
                var t = null;
                if (element.Indexed) {
                    t = item.Item.SystemFields.find(c => c.ItemName == element.ItemName);
                } else {
                    t = item.Result.find(c => c.ItemName == element.ItemName);
                }
                if (t) {
                    t.DisplayName = element.DisplayName;
                    t.RelateName = element.RelateName;
                }
                if (!subFormLayout || subFormLayout.length == 0) return;
                var l = subFormLayout.find(c => c.code == element.ParentProperty);
                if (l && l.Data && l.Data.layoutDetail && l.Data.layoutDetail.length > 0) {
                    var obj = this.getCtlByCode(l.Data.layoutDetail, element.ItemName);
                    if (obj) {
                        obj.title = element.DisplayName;
                    }
                }
                break;
            case PropertyState.Del:
                var r = null;
                if (element.Indexed) {
                    r = item.Item.SystemFields.find(c => c.ItemName == element.ItemName);
                    if (r && r.ExtendProperty && r.ExtendProperty.length > 0) {
                        r.ExtendProperty.forEach(se => {
                            se.IsDel = true;
                        });
                    }
                } else {
                    r = item.Result.find(c => c.ItemName == element.ItemName);
                }
                if (r) {
                    r.PropertyState = PropertyState.Del;
                    r.IsDel = true;
                }
                if (!subFormLayout || subFormLayout.length == 0) return;
                var ll = subFormLayout.find(c => c.code == element.ParentProperty);
                if (ll && ll.Data && ll.Data.layoutDetail && ll.Data.layoutDetail.length > 0) {
                    this.deleteCtlByCode(ll.Data.layoutDetail, element.ItemName);
                }
                break;
        }
    },
    updateMainItem(element, source, formLayout) {
        switch (element.PropertyState) {
            case PropertyState.Add:
                var exist = source.find(c => c.ItemName == element.ItemName);
                if (exist) {
                    exist.PropertyState = PropertyState.Add;
                    exist.IsDel = false;
                } else {
                    if (!element.Indexed ||
                        (element.Indexed && element.ItemName.indexOf('_Id') == -1)
                    ) {
                        source.push(element);
                    }
                }
                break;
            case PropertyState.Update:
                var sObj = source.find(r => r.ItemName == element.ItemName);
                if (sObj) {
                    sObj.DisplayName = element.DisplayName;
                    sObj.RelateName = element.RelateName;
                }
                if (formLayout && formLayout.Data && formLayout.Data.layoutDetail) {
                    var obj = this.getCtlByCode(formLayout.Data.layoutDetail, element.ItemName);
                    if (obj) {
                        obj.title = element.DisplayName;
                    }
                }
                break;
            case PropertyState.Del:
                var r = source.find(c => c.ItemName == element.ItemName);
                if (r) {
                    r.PropertyState = PropertyState.Del;
                    r.IsDel = true;
                    this.deleteCtlByCode(formLayout.Data.layoutDetail, element.ItemName);
                }
                break;
        }
    },
    createDataSourItem(
        schemaCode,
        displayName,
        propertyName,
        relateName,
        oldName,
        logicType,
        parentProperty,
        propertyState,
        dataFormat,
        componentKey,
        extendProperty = [],
        indexed = false
    ) {
        var sourceModel = new PropertySchemaViewModel();
        sourceModel.DefaultValue = null;
        sourceModel.DisplayName = displayName;
        sourceModel.Indexed = indexed;
        sourceModel.IsPublished = true;
        sourceModel.LogicType = logicType;
        sourceModel.ParentProperty = parentProperty;
        sourceModel.RecordTrail = false;
        sourceModel.SchemaCode = schemaCode;
        sourceModel.Searchable = false;
        sourceModel.VirtualField = false;
        sourceModel.PropertyState = propertyState;
        sourceModel.DataFormat = dataFormat;
        sourceModel.ComponentKey = componentKey;
        if (logicType == DataLogicType.BizObjectArray) {
            if (!propertyName) sourceModel.PropertyName = uuid(10, 16);
            else sourceModel.PropertyName = propertyName;
            if (!relateName) sourceModel.RelateName = 'i_' + sourceModel.PropertyName;
            else sourceModel.RelateName = relateName;
        } else {
            if (!propertyName) sourceModel.PropertyName = 'f_' + uuid(10, 16);
            else sourceModel.PropertyName = propertyName;
            if (!relateName) sourceModel.RelateName = sourceModel.PropertyName;
            else sourceModel.RelateName = relateName;
        }
        if (propertyState == PropertyState.Del || propertyState == PropertyState.Update ||
            logicType == "BizObjectArray") {
            sourceModel.Property = sourceModel.PropertyName;
        }
        if (propertyState == PropertyState.Update) {
            sourceModel.OldName = oldName;
        } else {
            sourceModel.OldName = null;
        }
        sourceModel.ItemName = sourceModel.PropertyName;

        if (extendProperty && extendProperty.length > 0) {
            sourceModel.ExtendProperty = extendProperty;
        }

        return sourceModel;
    },
    getComponent(code, title, componentKey = 'Text') {
        return {
            $type: 'S2Cloud.SmartFlow.Sheet.' + componentKey + ', S2Cloud.SmartFlow',
            tempVirtualType: 'S2Cloud.SmartFlow.Sheet.' + componentKey + ', S2Cloud.SmartFlow',
            componentKey: componentKey,
            isCurrentLogin: false,
            defaultValueType: 0,
            format: -1,
            defaultValue: '',
            computationRule: null,
            computationRuleFields: null,
            computationRuleText: null,
            computationRuleHtml: null,
            validateRule: null,
            isValidateRuleChecked: false,
            displayRule: '',
            displayRuleFields: [],
            ruleText: '',
            htmlText: '',
            disableRule: '',
            disableRuleFields: [],
            disableRuleText: '',
            disableRuleHtml: '',
            defaultRule: '',
            defaultRuleFields: [],
            defaultRuleText: '',
            defaultRuleHtml: '',
            operators: [
                'Contain',
                'NotContain',
                'Equal',
                'NotEqual',
                'IsNone',
                'NotNone',
                'StartWith',
                'EndWith',
            ],
            supportSearchControls: [
                'DateComponent',
                'DateInterval',
                'Person',
                'DepartmentOrg',
                'NumberComponent',
                'Money',
                'CheckBox',
                'Select',
                'RadioBox',
                'Text',
                'SerialNumber',
                'TextArea',
                'RichText',
                'Money',
                'Phone',
                'Mobile',
                'Email',
            ],
            isMobile: false,
            titleLayout: 'field-hoz',
            title: title,
            width: 155,
            order: 1,
            index: 0,
            fieldId: CreateUUID(),
            code: code,
            formCode: 'c6d798b1311ed7e5',
            table: '',
            describe: '',
            value: '',
            size: '',
            dataType: '',
            frontBack: 0,
            jsEvent: [],
            isView: true,
            isEdit: true,
            isMust: false,
            hiddenRule: [],
            isSubContainer: false,
            afterSerializable: null,
            autoLineWrap: false,
            // 流水号日期规则字段
            dataRule: 0,
        };
    },
    getDefaultComponent(code, title) {
        return this.getComponent(code, title);
    },
    getSubDefaultComponent(code, title) {
        return {
            $type: 'S2Cloud.SmartFlow.Sheet.SubTable, S2Cloud.SmartFlow',
            tempVirtualType: 'S2Cloud.SmartFlow.Sheet.SubTable, S2Cloud.SmartFlow',
            afterSerializable: null,
            autoLineWrap: false,
            code: code,
            componentKey: 'SubTable',
            dataType: '',
            describe: '',
            displayRule: '',
            displayRuleFields: [],
            fieldId: code,
            frontBack: 0,
            hiddenRule: [],
            htmlText: '',
            index: 0,
            initializeRule: null,
            isEdit: true,
            isMobile: false,
            isMust: false,
            isScrollData: false,
            isSubContainer: false,
            isView: true,
            jsEvent: [],
            layout: 0,
            layoutData: [],
            layoutDetail: [],
            operators: [],
            order: 11,
            title: title,
            value: '',
            width: 155,
        };
    },
    getCtlByCode(layoutDetail, code) {
        if (layoutDetail) {
            for (let index = 0; index < layoutDetail.length; index++) {
                const element = layoutDetail[index];
                if (element.code == code) {
                    return element;
                } else if (element.componentKey == 'ColumnPanel') {
                    for (let index1 = 0; index1 < element.layoutDetail.length; index1++) {
                        for (
                            let index2 = 0; index2 < element.layoutDetail[index1].layoutDetail.length; index2++
                        ) {
                            if (element.layoutDetail[index1].layoutDetail[index2].code == code) {
                                return element.layoutDetail[index1].layoutDetail[index2];
                            }
                        }
                    }
                }
            }
        }
    },
    deleteCtlByCode(layoutDetail, code) {
        if (layoutDetail) {
            for (let index = 0; index < layoutDetail.length; index++) {
                const element = layoutDetail[index];
                if (element.code == code) {
                    layoutDetail.splice(index, 1);
                    break;
                } else if (element.componentKey == 'ColumnPanel') {
                    for (let index1 = 0; index1 < element.layoutDetail.length; index1++) {
                        for (
                            let index2 = 0; index2 < element.layoutDetail[index1].layoutDetail.length; index2++
                        ) {
                            if (element.layoutDetail[index1].layoutDetail[index2].code == code) {
                                element.layoutDetail[index1].layoutDetail.splice(index2, 1);
                            }
                        }
                    }
                }
            }
        }
    },
    isNewField(source, code) {
        if (!source || !code || !source.dataSource) return false;
        //查主表
        if (
            source.dataSource.UserFields.Result.find(
                c => c.ItemName == code && c.PropertyState == PropertyState.Add
            )
        ) {
            return true;
        } else {
            //查子表
            if (!Array.isArray(source.dataSource.SubFields)) return false;
            for (const element of source.dataSource.SubFields) {
                if (element.Result) {
                    if (
                        element.Result.find(
                            c => c.ItemName == code && c.PropertyState == PropertyState.Add
                        )
                    ) {
                        return true;
                    }
                }
            }
        }
        return false;
    },
    getComponentByKey(controlPropertys, comKey, code, title) {
        var ctl = null;
        if (controlPropertys && controlPropertys.length > 0) {
            var cItem = controlPropertys.find(c => c.type == comKey);
            if (cItem && cItem.propertys && cItem.propertys.length > 0) {
                ctl = cItem.propertys[0].control;
                ctl['code'] = code;
                ctl['title'] = title;
                ctl['fieldId'] = CreateUUID();
            }
        }
        if (!ctl) ctl = this.getDefaultComponent(code, title);
        return ctl;
    },
    isObjectValueEqual(a, b, containAnEnum) {
        if (!a && !b) {
            return true;
        } else if (!a || !b) {
            return false;
        }
        const aProps = containAnEnum ? Object.getOwnPropertyNames(a) : Object.keys(a);
        const bProps = containAnEnum ? Object.getOwnPropertyNames(b) : Object.keys(b);
        if (aProps.length != bProps.length) {
            return false;
        }

        for (let i = 0; i < aProps.length; i++) {
            const propName = aProps[i];
            if (a[propName] !== b[propName]) {
                return false;
            }
        }
        return true;
    },
    toPrecision(num, precision) {
        if (isNaN(num)) {
            return 0;
        }
        if (precision === undefined) precision = 2;
        return parseFloat(Number(num).toFixed(precision));
    },
    /**
     * 获得字符串实际长度，中文2，英文1
     * @param {*} str 要获得长度的字符串
     */
    getLength(str) {
        var realLength = 0,
            len = str.length,
            charCode = -1;
        for (var i = 0; i < len; i++) {
            charCode = str.charCodeAt(i);
            if (charCode >= 0 && charCode <= 128) realLength += 1;
            else realLength += 2;
        }
        return realLength;
    },
    /**
     * 安装字符串实际长度截取
     * @param {a} str
     * @param {*} len
     */
    cutstr(str, len) {
        var str_length = 0;
        var str_len = str.length;
        let str_cut = new String();
        for (var i = 0; i < str_len; i++) {
            let a = str.charAt(i);
            str_length++;
            if (escape(a).length > 4) {
                //中文字符的长度经编码之后大于4
                str_length++;
            }
            str_cut = str_cut.concat(a);
            if (str_length >= len) {
                str_cut = str_cut.concat('...');
                return str_cut;
            }
        }
        //如果给定字符串小于指定长度，则返回源字符串；
        if (str_length < len) {
            return str;
        }
    },

    privacyProtection(value) {
        var str = '';
        for (var i = 0; i < value.length - 7; ++i) {
            str += '*';
        }
        return value.substring(0, 3) + str + value.substring(value.length - 4);
    },

    async globalConfigHandle(originalStr) {
        if (IsNull(originalStr)) {
            return Promise.resolve(originalStr);
        }

        const baseInfo = await systemService.getEntBaseInfo();
        let resultStr = originalStr;
        const regx = /##\w+##/g;
        const result = resultStr.match(regx);
        if (!result) {
            return Promise.resolve(originalStr);
        }

        for (let i = 0; i < result.length; i++) {
            const replaceStr = result[i];
            const key = replaceStr.substring(2, replaceStr.length - 2);
            if (baseInfo.hasOwnProperty(key) && !IsNull(baseInfo[key])) {
                resultStr = resultStr.replace(replaceStr, baseInfo[key]);
            }
        }
        return resultStr;
    },
    toFirstTabRouter(codeRouter, routerName, router, defaultRouter) {
        // if (!LoginService.userInfo.IsAdmin) {
        for (let index = 0; index < codeRouter.length; index++) {
            const element = codeRouter[index];
            if (element.name == routerName) {
                router.push({ name: element.name });
                return element.name;
            }
        }
        //}

        return defaultRouter;
    },
};